<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-10">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 terms-backdrop transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="terms-panel relative transform overflow-hidden text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <!-- Accent bar -->
              <div class="terms-bar"></div>
              <div class="p-6">
                <div>
                  <div class="mt-2 text-center">
                    <DialogTitle as="h3" class="terms-title">Acceptance of Terms</DialogTitle>
                    <ul role="list" class="terms-links">
                      <li>
                        <a href="https://cruzcontrolapp.s3.us-east-2.amazonaws.com/documents/CruzControl+Privacy+Policy.pdf" target="_blank" class="terms-link">Privacy Policy</a>
                      </li>
                      <li>
                        <a href="https://cruzcontrolapp.s3.us-east-2.amazonaws.com/documents/CruzControl+Acceptable+Use+Policy.pdf" target="_blank" class="terms-link">Acceptable Use Policy</a>
                      </li>
                      <li>
                        <a href="https://cruzcontrolapp.s3.us-east-2.amazonaws.com/documents/CruzControl+Terms+of+Service.pdf" target="_blank" class="terms-link">Terms of Service</a>
                      </li>
                      <li>
                        <a href="https://cruzcontrolapp.s3.us-east-2.amazonaws.com/documents/CruzControl+Website+Terms+and+Conditions.pdf" target="_blank" class="terms-link">Terms and Conditions</a>
                      </li>
                    </ul>
                    <div class="mt-3 text-left">
                      <p class="terms-body">By using this website, you are hereby accepting the terms and conditions stipulated within the Terms and Conditions, Privacy Policy, and Master Services Agreement. <br/><br/>If you are not in agreement with our terms and conditions, then you should refrain from further use of our sites. <br/><br/> In addition, your continued use of our website following the posting of any updates or changes to our terms and conditions shall mean that you agree and acceptance of such changes.</p>
                    </div>
                  </div>
                </div>
                <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-3 pt-4">
                  <div class="relative flex items-start col-span-3">
                    <div class="flex h-6 items-end">
                      <p id="acceptance-description" class="terms-accept-desc">Click here to indicate that you have read and agree to the terms presented in the Terms and Conditions agreement.</p>
                    </div>
                  </div>
                  <div class="relative flex justify-center col-start-2 mt-3">
                    <div class="flex h-6 items-center">
                      <input id="acceptance" aria-describedby="acceptance-description" name="acceptance" type="checkbox" @click="accept = true" class="h-4 w-4 rounded border-gray-600 text-primary focus:ring-primary bg-transparent" />
                    </div>
                    <div class="ml-3 text-sm leading-6">
                      <label for="acceptance" class="terms-accept-label">I ACCEPT</label>
                    </div>
                  </div>
                </div>
                <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button :onclick="SubmitAcceptance" :disabled="!accept" type="button" class="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary sm:col-start-2 disabled:opacity-40 uppercase" @click="open = false">Proceed</button>
                  <router-link to="/logout">
                    <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-red-700 px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-red-600 hover:bg-red-600 sm:col-start-1 sm:mt-0 uppercase" @click="open = false" ref="cancelButtonRef">Decline</button>
                  </router-link>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import {updateEULAAcceptance} from "@/services/user.service";
import {mapGetters} from "vuex";
import {store} from "@/store/store";
export default {
  name: "AcceptableUse",
  components: {
    DialogPanel,
    Dialog,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
  },
  props: {
    currentVersion: Number,
  },
  data() {
    return {
      open: true,
      accept: false,
    }
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  methods: {
    async SubmitAcceptance() {
      await store.commit('setUser', await updateEULAAcceptance(this.getUser.id, this.currentVersion))
      this.open = false;
    }
  }
}
</script>

<style scoped>
.terms-backdrop {
  background: var(--cc-backdrop);
  backdrop-filter: blur(4px);
  transition: background 0.3s;
}

.terms-panel {
  background: var(--cc-modal);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid var(--cc-modal-border);
  border-radius: 6px;
  box-shadow: var(--cc-modal-shadow);
  overflow: hidden;
  font-family: 'Barlow', sans-serif;
  transition: background 0.3s, border-color 0.3s, box-shadow 0.3s;
}

.terms-bar {
  height: 3px;
  background: linear-gradient(90deg, #0092bf 0%, #00bcf5 55%, #fcef60 100%);
}

.terms-title {
  font-family: 'Big Shoulders Display', sans-serif;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--cc-t1);
  text-transform: uppercase;
  margin: 0 0 1rem;
  transition: color 0.3s;
}

.terms-links {
  list-style: none;
  padding: 0;
  margin: 0 0 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}
.terms-link {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #0092bf;
  text-transform: uppercase;
  text-decoration: none;
  letter-spacing: 0.04em;
  transition: color 0.18s;
}
.terms-link:hover { color: #00bcf5; text-decoration: underline; }

.terms-body {
  font-size: 0.75rem;
  color: var(--cc-t3);
  line-height: 1.6;
  margin: 0;
  transition: color 0.3s;
}

.terms-accept-desc {
  font-size: 0.75rem;
  color: var(--cc-t3);
  font-style: italic;
  text-align: center;
  margin: 0;
  transition: color 0.3s;
}

.terms-accept-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--cc-t6);
  transition: color 0.3s;
}
</style>